<template>
  <section class="evidence">
    <div class="ev-head">
      <span class="block-title">佐证材料</span>
      <span class="block-tip">
        材料名称不要求完全一致，提供功能相近的管理文档、系统截图、表单记录均可（脱敏后上传）
      </span>
    </div>

    <div v-if="evidence" class="ev-body">
      <div v-if="evidence.common" class="ev-row">
        <span class="ev-k">通用材料</span>
        <span class="ev-v">{{ evidence.common }}</span>
      </div>
      <div v-if="evidence.proof" class="ev-row">
        <span class="ev-k">本条凭证</span>
        <span class="ev-v ev-proof">{{ evidence.proof }}</span>
      </div>
    </div>
    <p v-else class="ev-empty">该角色下暂无对应佐证材料，可提供功能相近的替代性证明。</p>

    <!-- 上传区：逻辑完整，本期由 ENABLE_EVIDENCE 关闭渲染 -->
    <el-upload
      class="ev-upload"
      action=""
      multiple
      :auto-upload="false"
      :file-list="fileList"
      :limit="10"
      :on-change="onChange"
      :on-remove="onRemove"
      :on-exceed="onExceed"
    >
      <el-button size="small" type="primary" plain>选择文件</el-button>
      <template #tip>
        <div class="ev-tip">
          支持 pdf / 图片 / 压缩包，单个不超过 20MB，最多 10 个。请去除人员姓名、身份证号等敏感信息。
        </div>
      </template>
    </el-upload>
  </section>
</template>

<script setup>
// 本组件由父级按 ENABLE_EVIDENCE 开关控制渲染（src/data/index.js），
// 上传逻辑已完整实现，打开开关即可直接使用。
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
  evidence: { type: Object, default: null },
  indicatorName: { type: String, default: '' },
  files: { type: Array, default: () => [] }
})

const emit = defineEmits(['update-files'])

const MAX_SIZE = 20 * 1024 * 1024

const fileList = ref([...props.files])

watch(() => props.files, (v) => {
  fileList.value = [...(v || [])]
})

function sync () {
  emit('update-files', fileList.value.map((f) => ({
    name: f.name,
    size: f.size,
    uid: f.uid
  })))
}

function onChange (file) {
  if (file.size > MAX_SIZE) {
    ElMessage.warning(`「${file.name}」超过 20MB，已移除`)
    fileList.value = fileList.value.filter((f) => f.uid !== file.uid)
    return
  }
  sync()
}

function onRemove (file) {
  fileList.value = fileList.value.filter((f) => f.uid !== file.uid)
  sync()
}

function onExceed () {
  ElMessage.warning('最多上传 10 个文件')
}
</script>

<style lang="scss" scoped>
.evidence {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.ev-head {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

.block-title {
  font-size: 13px;
  font-weight: 600;
  color: #1d1d1f;
}

.block-tip {
  font-size: 12px;
  color: #86868b;
}

.ev-body {
  padding: 12px 14px;
  background: rgba(120, 120, 128, 0.05);
  border-radius: 10px;
}

.ev-row {
  display: flex;
  gap: 12px;
  font-size: 12.5px;
  line-height: 1.8;

  & + & {
    margin-top: 6px;
  }
}

.ev-k {
  flex: 0 0 66px;
  color: #86868b;
}

.ev-v {
  flex: 1;
  color: #3a3a3c;
}

.ev-proof {
  font-weight: 500;
  color: #0071e3;
}

.ev-empty {
  margin: 0 0 12px;
  font-size: 12.5px;
  color: #86868b;
}

.ev-upload {
  margin-top: 12px;
}

.ev-tip {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.7;
  color: #86868b;
}
</style>
